import Vue from "vue";
import VueRouter from "vue-router";
import CheckPrivilege from "../views/CheckPrivilege.vue";
import Transaction from "../views/Transaction.vue";
import TransactionASC from "../views/TransactionASC.vue";
import SignInForm from "../views/SignInForm.vue";
import SignInFormASC from "../views/SignInFormASC.vue";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
import store from "../store";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "SignInForm",
    component: SignInForm,
  },
  {
    path: "/signinformASC",
    name: "SignInFormASC",
    component: SignInFormASC,
  },
  {
    path: "/checkprivilege",
    name: "CheckPrivilege",
    component: CheckPrivilege,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/transaction",
    name: "Transaction",
    component: Transaction,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/transactionASC",
    name: "TransactionASC",
    component: TransactionASC,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: "/servicedata",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.role == "user") {
      next();
    } else {
      next({ path: "/" });
    }
  } else {
    next();
  }
});

export default router;
